export const titleCase = (str: string) =>
  str?.length > 2
    ? `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`
    : str;
